import HowToScan  from './HowToScan';
export default HowToScan;